import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Container,
  VStack,
  Heading,
  Text,
  Spinner,
  useToast,
} from '@chakra-ui/react';
import { useSupabaseClient } from '@supabase/auth-helpers-react';
import RotaryLogo from './RotaryLogo';
import ProductName from './ProductName';

const VerificationSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [verifying, setVerifying] = useState(true);
  const supabase = useSupabaseClient();
  const toast = useToast();

  useEffect(() => {
    const handleVerification = async () => {
      try {
        // Get the token from the URL
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        const type = params.get('type');

        if (type === 'signup' && token) {
          // Verify the token
          const { error } = await supabase.auth.verifyOtp({
            token_hash: token,
            type: 'signup'
          });

          if (error) throw error;

          // Show success message
          toast({
            title: 'Email verified',
            description: 'Your email has been verified. You can now log in.',
            status: 'success',
            duration: 5000,
            isClosable: true,
          });

          // Redirect to profile setup after a short delay
          setTimeout(() => {
            navigate('/profile-setup');
          }, 2000);
        }
      } catch (error) {
        console.error('Verification error:', error);
        toast({
          title: 'Verification failed',
          description: 'There was an error verifying your email. Please try again or contact support.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } finally {
        setVerifying(false);
      }
    };

    handleVerification();
  }, [location, navigate, supabase.auth, toast]);

  return (
    <Container maxW="lg" py={{ base: '12', md: '24' }} px={{ base: '0', sm: '8' }}>
      <VStack spacing="8">
        <RotaryLogo width="100px" height="100px" />
        <ProductName />
        <Box textAlign="center">
          <Heading size="lg" mb={4}>Email Verification</Heading>
          {verifying ? (
            <VStack spacing={4}>
              <Spinner size="xl" />
              <Text>Verifying your email...</Text>
            </VStack>
          ) : (
            <Text>
              Redirecting you to the application...
            </Text>
          )}
        </Box>
      </VStack>
    </Container>
  );
};

export default VerificationSuccess;
